import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import TagsPage from 'ext:flarum/tags/forum/components/TagsPage';
import HeroBlock from './components/HeroBlock';
import SectionGrid from './components/SectionGrid';
import LatestDiscussions from './components/LatestDiscussions';
import { sectionNumber, sections, subsections } from './utils/sections';
import { startDiscussion } from './utils/actions';
const t = function (key, params) {
  if (params === void 0) {
    params = {};
  }
  return app.translator.trans(`tarotportal-theme.forum.home.${key}`, params);
};
const stat = (key, count) => app.translator.trans(`tarotportal-theme.forum.stats.${key}`, {
  count
});

/** The forum home ("/" → /tags): structure of the community first, latest discussions below. */
export default function addHome() {
  override(TagsPage.prototype, 'hero', function () {
    const all = sections();
    const total = all.reduce((sum, tag) => sum + (tag.discussionCount() || 0), 0);
    const subs = all.reduce((sum, tag) => sum + subsections(tag).length, 0);
    const rules = app.store.getBy('tags', 'slug', app.forum.attribute('tarotportalRulesTag') || '');
    return m(HeroBlock, {
      className: "TpHero--home",
      eyebrow: t('eyebrow'),
      title: t('title'),
      aside: m("p", {
        className: "TpHero-lead"
      }, t('lead')),
      strip: [m("span", {
        className: "TpMeta"
      }, stat('discussions', total), " \xB7 ", stat('sections', all.length), " \xB7 ", stat('subsections', subs)), m("div", {
        className: "TpHero-actions"
      }, m(Button, {
        className: "Button Button--primary TpButton",
        onclick: startDiscussion
      }, app.translator.trans('core.forum.index.start_discussion_button')), rules && m(Link, {
        className: "Button TpButton TpButton--outline",
        href: app.route.tag(rules)
      }, t('rules')))]
    });
  });
  override(TagsPage.prototype, 'sidebar', () => null);
  extend(TagsPage.prototype, 'contentItems', function (items) {
    if (!items.has('tagTiles')) return;
    items.remove('tagTiles');
    if (items.has('cloud')) items.remove('cloud');
    items.add('tp-sections', m("section", {
      className: "TpBlock TpSectionsBlock"
    }, m("div", {
      className: "TpBlock-head"
    }, m("div", null, m("p", {
      className: "TpEyebrow TpEyebrow--muted"
    }, t('sections_eyebrow')), m("h2", {
      className: "TpBlock-title"
    }, t('sections_title')), m("p", {
      className: "TpBlock-text"
    }, t('sections_text')))), m(SectionGrid, {
      variant: "sections",
      items: sections().map(tag => ({
        tag,
        number: sectionNumber(tag),
        children: subsections(tag)
      }))
    })), 100);
    items.add('tp-latest', m(LatestDiscussions, null), 90);
  });
}